import { useState, useEffect, useContext } from "react";
import {
  Backdrop,
  Box,
  Button,
  FormHelperText,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { postNotification } from "../../../components/utilities/Notifications";

import { Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { globalVariables } from "../../../global/GlobalVariables";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";
import StyledMenu from "../../../components/layout/StyledMenu";
import { userDisplayName } from "./EventFunctions";
import OrganizePlayerModal from "./OrganizePlayerModal";
import {
  BCPEllipsisVertical,
  BCPPlus,
  BCPTrash,
  BCPXmark
} from "../../../components/icons/bcp/BCPIcons";
import {
  deleteData,
  getData,
  postData
} from "../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import { AuthContext } from "../../../components/user/BCPAuthProvider";

const TermsOfServiceBox = () => {
  return (
    <Box>
      <Typography variant="caption" paragraph>
        By clickin "I agree", you agree to the Terms of Service for the{" "}
        {getEnvironmentVariable("COMPANY_NAME")} Website or Services, EULA, and
        Privacy Policy. You must be 13 years of age or older to use{" "}
        {getEnvironmentVariable("COMPANY_NAME")}. By agreeing you confirm that
        you are over 18, or if you are between 13 and 18 years of age, you have
        your parent or legal guardian's permission to use{" "}
        {getEnvironmentVariable("COMPANY_NAME")}
        We take privacy seriously and collect the following information to
        administer your account, scores, rankings and ticket sales. Your name is
        shared publicly as part of event rosters, pairings, placings and
        rankings. Your email address is kept private and used as our unique
        identifier and only shared with the Event Organizers of events you
        participate in, Team owners which you are a member of, and Vendors you
        make purchases from. {getEnvironmentVariable("COMPANY_NAME")} may
        contact you occasionally in relation to services requested.
      </Typography>
      <Typography variant="caption">
        Visit these links for our complete{" "}
        <Link href="/privacy" target="_blank">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link href="/eula" target="_blank">
          EULA
        </Link>
        .
      </Typography>
    </Box>
  );
};

const NonPlayingMemberModal = (props) => {
  const {
    values,
    nonPlayingMember,
    setNonPlayingMember,
    submitNonTeamMember,
    setLoading
  } = props;
  const [nonPlayingMemberState, setNonPlayingMemberState] = useState(
    nonPlayingMember ? { ...nonPlayingMember } : null
  );

  useEffect(() => {
    setNonPlayingMemberState(nonPlayingMember ? { ...nonPlayingMember } : null);

    // eslint-disable-next-line
  }, [nonPlayingMember]);

  if (!nonPlayingMember) return <></>;

  return (
    <>
      <Modal
        disableAutoFocus
        open
        onClose={() => {
          setNonPlayingMember(null);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            minHeight: "95vh",
            maxHeight: "95vh",
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setNonPlayingMember(null);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h4" component="h2">
                Coach / Assistant / Non Playing Member
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                name="email"
                label="Email"
                required
                value={nonPlayingMemberState?.email || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                onBlur={async (e) => {
                  if (e.target.value !== "") {
                    setLoading(true);
                    try {
                      const apiUser = await getData(`/users/${e.target.value}`);
                      if (apiUser) {
                        if (
                          values?.nonPlayingMembers?.filter(
                            (el) => el.userId === apiUser.id
                          )?.length > 0
                        ) {
                          postNotification(
                            "warning",
                            "User already a non playing member"
                          );
                          setNonPlayingMemberState({ email: "" });
                        } else {
                          setNonPlayingMemberState({
                            index: nonPlayingMember?.index,
                            userId: apiUser.id,
                            email: apiUser?.email || e.target.value,
                            firstName: apiUser.firstName,
                            lastName: apiUser.lastName
                          });
                        }
                      } else {
                        throw new Error("User not found");
                      }
                    } catch (err) {
                      postNotification("warning", "User not found");
                      setNonPlayingMemberState({ email: "" });
                    }
                    setLoading(false);
                  } else {
                    setNonPlayingMemberState({ email: "" });
                  }
                }}
                onChange={(e) => {
                  setNonPlayingMemberState({ email: e.target.value || "" });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="firstName"
                label="First Name"
                value={nonPlayingMemberState?.firstName || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="lastName"
                label="Last Name"
                value={nonPlayingMemberState?.lastName || ""}
                variant="outlined"
                fullWidth
                margin="normal"
                disabled
              />
            </Grid>

            <Grid item xs={6}>
              <Button
                color="error"
                fullWidth
                variant="outlined"
                onClick={() => {
                  setNonPlayingMember(null);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                color="success"
                fullWidth
                variant="contained"
                disabled={!nonPlayingMemberState?.userId}
                onClick={() => {
                  submitNonTeamMember(nonPlayingMemberState);
                }}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default function OrganizeTeamPlayerModal(props) {
  const { event, teamPlayer, setTeamPlayer, armies, setRefreshPlayers } = props;

  const authContext = useContext(AuthContext);

  var globalVars = globalVariables();
  const confirm = useConfirm();

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [captainIsPlayer, setCaptainIsPlayer] = useState(false);

  const [transaction, setTransaction] = useState(null);

  const [player, setPlayer] = useState(null);
  const [nonPlayingMember, setNonPlayingMember] = useState(null);
  const [passwordUpdated, setPasswordUpdated] = useState(false);

  const submitTeamPlayer = async (values) => {
    if (values.checkedIn) {
      var error = false;
      if (
        event.enablePasswords &&
        !event.passwordlessScoring &&
        values.pin === "" &&
        !teamPlayer.hasPin
      ) {
        postNotification("error", "Please enter a pin");
        error = true;
      }
      if (error) return;
    }
    setLoading(true);
    try {
      if (teamPlayer.id) {
        let body = { set: {}, unset: {} };
        body.set.name = values.name;
        if (values.checkedIn !== undefined) {
          body.set.checkedIn = values.checkedIn;
        }
        if (values.pin && passwordUpdated) {
          body.set.pin = values.pin;
        }

        if (values.fixedTable && values.fixedTable !== "") {
          body.set.fixedTable = values.fixedTable;
        } else {
          body.unset.fixedTable = true;
        }

        if (values.captainId) {
          body.set.captainId = values.captainId;
        } else {
          body.set.teamCaptain = {};
          if (values.email) {
            body.set.teamCaptain.email = values.email;
          }
          if (values.firstName) {
            body.set.teamCaptain.firstName = values.firstName;
          }
          if (values.lastName) {
            body.set.teamCaptain.lastName = values.lastName;
          }
        }

        if (values?.players?.length) {
          body.players = [];
          values.players.forEach((player) => {
            if (player.user || player.isCaptain) {
              var newPlayer = {
                eventId: values.eventId,

                id: player.id,
                userId: player.userId,
                playerId: player.playerId,

                ...player
              };
              delete newPlayer.armyList;
              delete newPlayer.armyListHTML;
              delete newPlayer.armyListObjectId;
              delete newPlayer.armyListText;
              let playerFields = [
                "teamId",
                "armyId",
                "subFactionId",
                "characterId",
                "checkedIn"
              ];
              for (let playerField of playerFields) {
                if (player[playerField] !== undefined) {
                  newPlayer[playerField] = player[playerField];
                }
              }

              body.players.push(newPlayer);
            }
          });
        }

        body.nonPlayingMembers = [];
        if (values?.nonPlayingMembers?.length) {
          values.nonPlayingMembers.forEach((nonPlayingMember) => {
            if (nonPlayingMember.userId) {
              body.nonPlayingMembers.push({ userId: nonPlayingMember.userId });
            }
          });
        }

        await postData(`/teamplayers/${teamPlayer.id}`, {
          body: body
        });
      } else {
        let body = {};
        body.name = values.name;
        if (values.eventId) {
          body.eventId = values.eventId;
        }
        if (values.checkedIn !== undefined) {
          body.checkedIn = values.checkedIn;
        }
        if (values.pin && passwordUpdated) {
          body.pin = values.pin;
        }

        if (values.fixedTable && values.fixedTable !== "") {
          body.fixedTable = values.fixedTable;
        }

        if (values.captainId) {
          body.captainId = values.captainId;
        } else {
          body.teamCaptain = {};
          if (values.email) {
            body.teamCaptain.email = values.email;
          }
          if (values.firstName) {
            body.teamCaptain.firstName = values.firstName;
          }
          if (values.lastName) {
            body.teamCaptain.lastName = values.lastName;
          }
        }

        if (values?.players?.length) {
          body.players = [];
          values.players.forEach((player) => {
            if (player.user || player.isCaptain) {
              var newPlayer = {
                eventId: values.eventId,

                id: player.id,
                userId: player.userId,
                user: player.user,
                playerId: player.playerId,

                ...player
              };
              let playerFields = [
                "teamId",
                "armyId",
                "subFactionId",
                "characterId",
                "checkedIn"
              ];
              for (let playerField of playerFields) {
                if (player[playerField] !== undefined) {
                  newPlayer[playerField] = player[playerField];
                }
              }
              body.players.push(newPlayer);
            }
          });
        }

        body.nonPlayingMembers = [];
        if (values?.nonPlayingMembers?.length) {
          values.nonPlayingMembers.forEach((nonPlayingMember) => {
            if (nonPlayingMember.userId) {
              body.nonPlayingMembers.push({ userId: nonPlayingMember.userId });
            }
          });
        }

        await postData(`/teamplayers`, {
          body: body
        });
      }
      setRefreshPlayers(true);
      setCaptainIsPlayer(false);
      setPlayer(null);
      setTeamPlayer(null);
    } catch (err) {
      postNotification("error", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (teamPlayer?.players?.length) {
      for (let p of teamPlayer.players) {
        if (p?.user?.id && p.user?.id === teamPlayer?.captain?.id) {
          setCaptainIsPlayer(true);
          break;
        }
      }
    }

    const go = async () => {
      if (teamPlayer?.transactionId) {
        setLoading(true);
        try {
          var apiTransaction = await getData(
            `/transactions/${teamPlayer.transactionId}`,
            {
              queryStringParameters: {
                "expand[]": ["refund"]
              }
            }
          );
          setTransaction(apiTransaction);
        } catch (err) {
          setTransaction(null);
          postNotification("error", err);
        }
        setLoading(false);
      } else {
        setTransaction(null);
      }
    };
    go();
  }, [teamPlayer]);

  return (
    <>
      <Modal
        disableAutoFocus
        open={Boolean(teamPlayer)}
        onClose={() => {
          setCaptainIsPlayer(false);
          setTeamPlayer(null);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        {teamPlayer ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: ["95vw", "85vw", 600],
              minHeight: "95vh",
              maxHeight: "95vh",
              overflowY: "scroll",
              bgcolor: "background.paper",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 24,
              p: 4
            }}
          >
            <IconButton
              aria-label="cancel"
              color="error"
              sx={{ position: "absolute", top: "4px", right: "4px" }}
              onClick={() => {
                setCaptainIsPlayer(false);
                setTeamPlayer(null);
              }}
            >
              <BCPXmark />
            </IconButton>
            <Grid
              container
              spacing={2}
              sx={{
                pb: 1,
                mb: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
              }}
            >
              <Grid item xs={12}>
                <Typography variant="h4" component="h2">
                  Team Details
                </Typography>
              </Grid>
            </Grid>

            <Formik
              initialValues={{
                name: teamPlayer?.name || "",
                email: teamPlayer?.captain?.email || "",
                firstName: teamPlayer?.captain?.firstName || "",
                lastName: teamPlayer?.captain?.lastName || "",
                fixedTable: teamPlayer?.fixedTable || "",
                pin: teamPlayer?.hasPin ? "****" : "",
                players: teamPlayer?.players || [],
                nonPlayingMembers: teamPlayer?.nonPlayingMembers || []
              }}
              enableReinitialize
              validationSchema={Yup.object().shape({
                name: Yup.string().min(3).max(128).required("Required"),
                email: event?.gameSystem?.emailRequired
                  ? Yup.string()
                      .nullable()
                      .max(128)
                      .email("Must be a valid email")
                      .required("Required")
                  : Yup.string()
                      .nullable()
                      .max(128)
                      .email("Must be a valid email"),
                firstName: Yup.string().max(128).required("Required"),
                lastName: Yup.string().max(128).required("Required"),
                fixedTable: Yup.number().nullable().min(0),
                pin:
                  teamPlayer?.id || event?.passwordlessScoring
                    ? Yup.string().max(255)
                    : Yup.string().max(255).required("Required")
              })}
              onSubmit={async (values) => {
                const filteredPlayers = values.players.filter(
                  (player) => player !== undefined && player !== null
                );

                values.players = filteredPlayers;

                try {
                  if (!teamPlayer?.id) {
                    await confirm({
                      title: `Terms of Service.`,
                      description: <TermsOfServiceBox />,
                      dialogProps: {
                        sx: {
                          zIndex: 99999
                        }
                      },
                      confirmationText: "I Agree",
                      cancellationText: "Cancel"
                    });

                    if (!values.email || values.email === "") {
                      await confirm({
                        title: `No Email`,
                        description:
                          "With no email address on record this event will not be linked to any other events. Are you sure you wish to register with no email?",
                        dialogProps: {
                          sx: {
                            zIndex: 99999
                          }
                        },
                        confirmationText: "Yes",
                        cancellationText: "No"
                      });
                    }
                  }
                } catch (err) {
                  return;
                }
                setLoading(true);

                var body = {
                  eventId: event?.id,
                  ...values
                };

                if (!values.email || values.email === "") {
                  delete body.email;
                }
                if (
                  !passwordUpdated ||
                  !event?.enablePasswords ||
                  event?.passwordlessScoring ||
                  !values.pin ||
                  values.pin === ""
                ) {
                  delete body.pin;
                }
                if (!values.armyId || values.armyId === "") {
                  delete body.armyId;
                }
                if (!values.subFactionId || values.subFactionId === "") {
                  delete body.subFactionId;
                }
                if (!values.teamName || values.teamName === "") {
                  delete body.teamName;
                }
                if (!values.fixedTable || values.fixedTable === "") {
                  delete body.fixedTable;
                }

                await submitTeamPlayer(body);
                setLoading(false);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
                setFieldValue
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TextField
                        name="name"
                        label="Team Name"
                        value={values.name}
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="email"
                        label={`Team Captain Email${
                          event?.gameSystem?.emailRequired ? "" : " (OPTIONAL)"
                        }`}
                        required={event?.gameSystem?.emailRequired}
                        value={values.email}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onBlur={async (e) => {
                          handleBlur(e);
                          if (e.target.value !== "") {
                            setLoading(true);
                            try {
                              var apiUser = await getData(
                                `/users/${e.target.value}`,
                                {
                                  queryStringParameters: {
                                    "expand[]": ["team"]
                                  }
                                }
                              );
                              if (apiUser) {
                                setFieldValue("userId", apiUser.id);
                                if (apiUser.firstName)
                                  setFieldValue("firstName", apiUser.firstName);
                                if (apiUser.lastName)
                                  setFieldValue("lastName", apiUser.lastName);
                              } else {
                                setFieldValue("userId", null);
                              }
                            } catch (err) {}
                            setLoading(false);
                          } else {
                            setFieldValue("userId", null);
                          }
                        }}
                        onChange={(e) => {
                          const trimmedString = e.target.value
                            .trim()
                            .toLowerCase();
                          setFieldValue("email", trimmedString);
                        }}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="firstName"
                        label="Team Captain First Name"
                        value={values.firstName}
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.firstName && errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        name="lastName"
                        label="Team Captain Last Name"
                        value={values.lastName}
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={Boolean(touched.lastName && errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                      />
                    </Grid>

                    {!event?.boardGameEvent &&
                      (authContext?.authState?.identity?.betaUser === "true" ||
                        authContext?.authState?.identity?.isAdmin ||
                        authContext?.authState?.identity?.adminGameSystems
                          ?.length > 0) && (
                        <Grid item xs={12}>
                          <TextField
                            name="fixedTable"
                            label="Fixed Table"
                            value={values.fixedTable}
                            variant="outlined"
                            fullWidth
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={Boolean(
                              touched.fixedTable && errors.fixedTable
                            )}
                            helperText={touched.fixedTable && errors.fixedTable}
                            type="number"
                            inputProps={{
                              min: 0
                            }}
                          />
                          <FormHelperText>
                            By setting a fixed table, each round this team will
                            play their game on this table, regardless of
                            placings.
                          </FormHelperText>
                        </Grid>
                      )}

                    {!event?.passwordlessScoring && (
                      <Grid item xs={12}>
                        <TextField
                          name="pin"
                          label="Team Captain Self Score Pin"
                          value={values.pin}
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          onBlur={(e) => {
                            handleBlur(e);
                          }}
                          onChange={(e) => {
                            handleChange(e);
                            setPasswordUpdated(true);
                          }}
                          onFocus={(e) => {
                            setFieldValue("pin", "");
                          }}
                          error={Boolean(touched.pin && errors.pin)}
                          helperText={touched.pin && errors.pin}
                          type="password"
                          required={!teamPlayer?.id}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} textAlign="center">
                      <Typography variant="body1">Players</Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid
                        container
                        sx={{
                          pb: 1,
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                          borderRadius: "4px"
                        }}
                      >
                        <FieldArray
                          name="players"
                          render={(arrayHelpers) => (
                            <>
                              {values?.players?.length > 0 &&
                                values?.players
                                  ?.filter(
                                    (player) =>
                                      (player?.firstName ||
                                        player?.user?.firstName) &&
                                      (player?.lastName ||
                                        player?.user?.lastName)
                                  )
                                  .map((player, index) => {
                                    return (
                                      <Grid
                                        key={index}
                                        item
                                        xs={12}
                                        sx={{
                                          p: 1,
                                          borderBottom:
                                            "1px solid rgba(0, 0, 0, 0.12)",
                                          "&:hover": {
                                            cursor: "pointer"
                                          }
                                        }}
                                        onClick={async (e) => {
                                          try {
                                            // Adds email value to player if missing
                                            if (
                                              (player?.userId ||
                                                player?.user?.id) &&
                                              !player?.user?.email &&
                                              !player?.email
                                            ) {
                                              const apiUser = await getData(
                                                `/users/${
                                                  player?.userId ||
                                                  player?.captain?.id
                                                }`
                                              );
                                              if (apiUser?.email) {
                                                player.user.email =
                                                  apiUser.email;
                                              }
                                            }
                                          } catch (err) {
                                          } finally {
                                            setPlayer({
                                              ...player,
                                              index: index
                                            });
                                          }
                                        }}
                                      >
                                        <Typography variant="body1">
                                          {userDisplayName(
                                            player?.firstName ||
                                              player?.user?.firstName,
                                            player?.lastName ||
                                              player?.user?.lastName
                                          )}
                                        </Typography>
                                      </Grid>
                                    );
                                  })}
                              {!captainIsPlayer && (
                                <Grid
                                  item
                                  xs={12}
                                  sx={{
                                    p: 1,
                                    textAlign: "center"
                                  }}
                                >
                                  <Button
                                    type="button"
                                    color="primary"
                                    variant="outlined"
                                    startIcon={<BCPPlus />}
                                    onClick={() => {
                                      var newPlayer = {
                                        index: values.players.length,
                                        isCaptain: true,
                                        email: values.email,
                                        firstName: values.firstName,
                                        lastName: values.lastName,
                                        pin: values.pin
                                      };
                                      arrayHelpers.push(newPlayer);
                                      setPlayer(newPlayer);
                                      setCaptainIsPlayer(true);
                                    }}
                                  >
                                    Add Captain as Player
                                  </Button>
                                </Grid>
                              )}
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  p: 1,
                                  textAlign: "center"
                                }}
                              >
                                <Button
                                  type="button"
                                  color="primary"
                                  variant="outlined"
                                  startIcon={<BCPPlus />}
                                  onClick={() => {
                                    arrayHelpers.push({});
                                    setPlayer({
                                      index: values.players.length
                                    });
                                  }}
                                >
                                  Add Player
                                </Button>
                              </Grid>
                            </>
                          )}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} textAlign="center">
                      <Typography variant="body1">
                        Non Playing Members / Coaches
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid
                        container
                        sx={{
                          pb: 1,
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                          borderRadius: "4px"
                        }}
                      >
                        <FieldArray
                          name="nonPlayingMembers"
                          render={(arrayHelpers) => (
                            <>
                              {values.nonPlayingMembers?.length > 0 &&
                                values.nonPlayingMembers.map(
                                  (nonPlayer, index) => {
                                    return (
                                      <>
                                        <Grid
                                          key={`nonPlayer${index}A`}
                                          item
                                          xs={10}
                                          sx={{
                                            p: 1,
                                            borderBottom:
                                              "1px solid rgba(0, 0, 0, 0.12)"
                                          }}
                                        >
                                          <Typography variant="body1">
                                            {userDisplayName(
                                              nonPlayer?.firstName ||
                                                nonPlayer?.user?.firstName,
                                              nonPlayer?.lastName ||
                                                nonPlayer?.user?.lastName
                                            )}
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          key={`nonPlayer${index}B`}
                                          item
                                          xs={2}
                                          sx={{
                                            p: 1,
                                            borderBottom:
                                              "1px solid rgba(0, 0, 0, 0.12)"
                                          }}
                                          textAlign="right"
                                        >
                                          <IconButton
                                            aria-label="remove"
                                            // color="error"
                                            onClick={() => {
                                              arrayHelpers.remove(index);
                                            }}
                                          >
                                            <BCPTrash
                                              sx={{
                                                fontSize: "12px"
                                              }}
                                            />
                                          </IconButton>
                                        </Grid>
                                      </>
                                    );
                                  }
                                )}

                              <Grid
                                item
                                xs={12}
                                sx={{
                                  p: 1,
                                  textAlign: "center"
                                }}
                              >
                                <Button
                                  type="button"
                                  color="primary"
                                  variant="outlined"
                                  startIcon={<BCPPlus />}
                                  onClick={() => {
                                    let newIndex =
                                      values.nonPlayingMembers?.length || 0;
                                    setNonPlayingMember({
                                      index: newIndex
                                    });
                                  }}
                                >
                                  Add Non Playing Member
                                </Button>
                              </Grid>
                            </>
                          )}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="caption" color="text.secondary">
                        In order to use the Website or Services provided by{" "}
                        {globalVars?.site?.title} you must be 13 years of age or
                        older. By submitting your information, you confirm that
                        you are over 18 years of age, or if you are between 13
                        and 18 years of age, you have your parent or legal
                        guardian's permission to use our Website or Services.
                        Please review our{" "}
                        <Link href="/privacy" target="_blank">
                          Privacy
                        </Link>{" "}
                        and{" "}
                        <Link href="/terms" target="_blank">
                          Website Terms of Use
                        </Link>{" "}
                        for more information.
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={!teamPlayer.id ? 6 : teamPlayer.checkedIn ? 10 : 5}
                    >
                      <Button
                        color="success"
                        fullWidth
                        variant="contained"
                        type="submit"
                      >
                        {teamPlayer.id ? "Update" : "Register"}
                      </Button>
                    </Grid>
                    {!teamPlayer.checkedIn && (
                      <Grid item xs={!teamPlayer.id ? 6 : 5}>
                        <Button
                          color="success"
                          fullWidth
                          variant="contained"
                          onClick={async (e) => {
                            var body = {
                              ...values,
                              checkedIn: true,
                              dropped: false,
                              eventId: event?.id
                            };

                            try {
                              if (!teamPlayer?.id) {
                                await confirm({
                                  title: `Terms of Service.`,
                                  description: <TermsOfServiceBox />,
                                  dialogProps: {
                                    sx: {
                                      zIndex: 99999
                                    }
                                  },
                                  confirmationText: "I Agree",
                                  cancellationText: "Cancel"
                                });

                                if (!values.email || values.email === "") {
                                  await confirm({
                                    title: `No Email`,
                                    description:
                                      "With no email address on record this event will not be linked to any other events. Are you sure you wish to register with no email?",
                                    dialogProps: {
                                      sx: {
                                        zIndex: 99999
                                      }
                                    },
                                    confirmationText: "Yes",
                                    cancellationText: "No"
                                  });
                                }
                              }
                            } catch (err) {
                              return;
                            }

                            await submitTeamPlayer(body);
                          }}
                        >
                          Check In
                        </Button>
                      </Grid>
                    )}
                    {teamPlayer.id && (
                      <Grid item xs={2}>
                        <Button
                          color="secondary"
                          variant="contained"
                          fullWidth
                          onClick={(e) => {
                            setOptionsAnchorEl(e.currentTarget);
                          }}
                          sx={{ minWidth: "100%", maxWidth: "100%" }}
                        >
                          <BCPEllipsisVertical />
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                  {teamPlayer.id && (
                    <OptionsMenu
                      event={event}
                      teamPlayer={teamPlayer}
                      transaction={transaction}
                      setTeamPlayer={setTeamPlayer}
                      setCaptainIsPlayer={setCaptainIsPlayer}
                      anchorEl={optionsAnchorEl}
                      setAnchorEl={setOptionsAnchorEl}
                      setLoading={setLoading}
                      setRefreshPlayers={setRefreshPlayers}
                      setPlayer={setPlayer}
                    />
                  )}

                  <OrganizePlayerModal
                    organize={true}
                    player={player}
                    setPlayer={setPlayer}
                    event={event}
                    armies={armies}
                    setRefreshPlayers={setRefreshPlayers}
                    teamSubmitPlayer={(newPlayer) => {
                      setFieldValue(`players[${player.index}]`, newPlayer);
                      setPlayer(null);
                    }}
                    teamCancelPlayer={(cancelPlayer) => {
                      if (
                        !cancelPlayer?.firstName &&
                        !cancelPlayer?.lastName &&
                        !cancelPlayer?.user
                      ) {
                        setFieldValue(
                          "players",
                          values.players.filter(
                            (el) => el.index !== cancelPlayer.index
                          )
                        );
                      }
                    }}
                    setCaptainIsPlayer={setCaptainIsPlayer}
                    setTeamPlayer={setTeamPlayer}
                  />

                  <NonPlayingMemberModal
                    values={values}
                    organize={true}
                    nonPlayingMember={nonPlayingMember}
                    setNonPlayingMember={setNonPlayingMember}
                    setLoading={setLoading}
                    submitNonTeamMember={(newNonPlayingMember) => {
                      setFieldValue(
                        `nonPlayingMembers[${newNonPlayingMember.index}]`,
                        newNonPlayingMember
                      );
                      setNonPlayingMember(null);
                    }}
                  />
                </form>
              )}
            </Formik>
          </Box>
        ) : (
          <></>
        )}
      </Modal>

      {Boolean(loading) && <ModalLoadingFull />}
    </>
  );
}

function OptionsMenu(props) {
  const {
    teamPlayer,
    transaction,
    setTeamPlayer,
    setCaptainIsPlayer,
    setLoading,
    anchorEl,
    setAnchorEl,
    setPlayer,
    setRefreshPlayers,
    event
  } = props;
  const open = Boolean(anchorEl);
  const confirm = useConfirm();
  return (
    <StyledMenu
      id="options-menu"
      MenuListProps={{
        "aria-labelledby": "options-button"
      }}
      disableScrollLock
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
    >
      <MenuItem
        onClick={async (e) => {
          setAnchorEl(null);
          try {
            await confirm({
              title: `Confirm Remove.`,
              description: "Are you sure you want to remove this team?",
              confirmationText: "Yes",
              dialogProps: {
                sx: {
                  zIndex: 99999
                }
              }
            });
          } catch (err) {
            return;
          }

          if (teamPlayer.transactionId && event?.chargeType === "square") {
            try {
              await confirm({
                title: `No Refund Available.`,
                description:
                  "It is not possible to refund players for Square transactions through BCP. If you would like to refund this team, please do so through your Square Dashboard. Do you still want to remove this team from the event?",
                confirmationText: "Yes",
                dialogProps: {
                  sx: {
                    zIndex: 99999
                  }
                }
              });
            } catch (err) {
              return;
            }
          } else if (teamPlayer.transactionId) {
            try {
              setLoading(true);
              await confirm({
                title: `Refund User.`,
                description:
                  "Would you like to refund the ticket for this team?",
                confirmationText: "Yes",
                cancellationText: "No",
                dialogProps: {
                  sx: {
                    zIndex: 99999
                  }
                }
              });

              await confirm({
                title: `Are you sure?`,
                description:
                  "Are you sure you would like to refund the ticket for this team? This action cannot be undone.",
                confirmationText: "Yes",
                cancellationText: "No",
                dialogProps: {
                  sx: {
                    zIndex: 99999
                  }
                }
              });

              // refund the ticket...
              try {
                await postData(
                  `/transactions/${teamPlayer.transactionId}/refundTransaction`
                );
              } catch (err) {
                setLoading(false);
                postNotification("error", err);
                return;
              }
            } catch (err) {}
          }

          try {
            setLoading(true);
            await deleteData(`/teamplayers/${teamPlayer.id}`);
            setRefreshPlayers(true);
            setLoading(false);
            setPlayer(null);
            setCaptainIsPlayer(false);
            setTeamPlayer(null);
          } catch (err) {
            setLoading(false);
            postNotification("error", err);
          }
        }}
        sx={{ color: "error.main" }}
        disableRipple
      >
        Delete From Event
      </MenuItem>
      {!teamPlayer.dropped ? (
        <MenuItem
          onClick={async (e) => {
            setAnchorEl(null);
            try {
              await confirm({
                title: `Confirm Drop.`,
                description: "Are you sure you want to drop this team?",
                dialogProps: {
                  sx: {
                    zIndex: 99999
                  }
                }
              });
            } catch (err) {
              return;
            }

            try {
              setLoading(true);

              await postData(`/teamplayers/${teamPlayer.id}`, {
                body: {
                  set: {
                    dropped: true
                  }
                }
              });
            } catch (err) {
              postNotification("error", err);
            }
            setRefreshPlayers(true);
            setLoading(false);
            setPlayer(null);
            setCaptainIsPlayer(false);
            setTeamPlayer(null);
          }}
          disableRipple
          sx={{ color: "error.main" }}
        >
          Drop Team
        </MenuItem>
      ) : (
        <MenuItem
          onClick={async (e) => {
            setAnchorEl(null);

            try {
              setLoading(true);

              await postData(`/teamplayers/${teamPlayer.id}`, {
                body: {
                  set: {
                    dropped: false
                  }
                }
              });
            } catch (err) {
              postNotification("error", err);
            }
            setRefreshPlayers(true);
            setLoading(false);
            setPlayer(null);
            setCaptainIsPlayer(false);
            setTeamPlayer(null);
          }}
          disableRipple
          sx={{ color: "error.main" }}
        >
          Undrop Team
        </MenuItem>
      )}
      {teamPlayer.transactionId &&
        !transaction?.refundId &&
        event?.chargeType !== "square" && (
          <MenuItem
            onClick={async (e) => {
              setAnchorEl(null);
              try {
                await confirm({
                  title: `Confirm Refund.`,
                  description: "Are you sure you want to refund this team?",
                  dialogProps: {
                    sx: {
                      zIndex: 99999
                    }
                  }
                });
              } catch (err) {
                return;
              }

              try {
                setLoading(true);

                await postData(
                  `/transactions/${teamPlayer.transactionId}/refundTransaction`
                );

                postNotification("success", "Team refunded");
                setLoading(false);
                setPlayer(null);
              } catch (err) {
                setLoading(false);
                postNotification("error", err);
              }
            }}
            sx={{ color: "error.main" }}
            disableRipple
          >
            Refund Player
          </MenuItem>
        )}
      {teamPlayer.dropped && (
        <MenuItem
          onClick={async (e) => {
            setAnchorEl(null);
            try {
              await confirm({
                title: `Confirm Undrop.`,
                description: "Are you sure you want to undrop this team?",
                dialogProps: {
                  sx: {
                    zIndex: 99999
                  }
                }
              });
            } catch (err) {
              return;
            }

            setLoading(true);
            try {
              await postData(`/teamplayers/${teamPlayer.id}`, {
                body: {
                  set: {
                    dropped: false
                  }
                }
              });
              postNotification(
                "info",
                "Team has been undropped. Players on the team also need to be undropped individually."
              );
            } catch (err) {
              postNotification("error", err);
            }
            setRefreshPlayers(true);
            setLoading(false);
            setPlayer(null);
            setCaptainIsPlayer(false);
            setTeamPlayer(null);
            setAnchorEl(null);
          }}
          disableRipple
        >
          Undo Drop
        </MenuItem>
      )}
      {teamPlayer.checkedIn && (
        <MenuItem
          onClick={async (e) => {
            setLoading(true);
            try {
              await postData(`/teamplayers/${teamPlayer.id}`, {
                body: {
                  set: {
                    checkedIn: false
                  }
                }
              });

              if (teamPlayer?.players && teamPlayer?.players?.length) {
                for (let singlePlayer of teamPlayer?.players) {
                  if (!singlePlayer?.dropped) {
                    await postData(`/players/${singlePlayer?.id}`, {
                      body: {
                        set: { checkedIn: false }
                      }
                    });
                  }
                }
              }
            } catch (err) {
              postNotification("error", err);
            }
            setRefreshPlayers(true);
            setLoading(false);
            setPlayer(null);
            setCaptainIsPlayer(false);
            setTeamPlayer(null);
            setAnchorEl(null);
          }}
          disableRipple
        >
          Undo Check In
        </MenuItem>
      )}
    </StyledMenu>
  );
}
